export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/dealer/deleteDealer',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['allDealers'],
       
    })


